import script from "./BookingCheckout.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingCheckout.vue?vue&type=script&setup=true&lang=js"

import "./BookingCheckout.vue?vue&type=style&index=0&id=5ce6c672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce6c672"]])

export default __exports__